import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';

export const hasKaseyaStoreLoginAccessGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const { targetPage } = route.queryParams;

  if (!targetPage) {
    return router.createUrlTree([ApplicationPath.Login]);
  }

  return true;
};
